<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>
    <navbar>
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3" >
            <span class="font-weight-light"></span>
            <span class="font-weight-medium">Users</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
    </navbar>
    <v-content class="secondary--text text--darken-2">
      <v-container fluid>
        <resource-view
          :validation-rules="validationRules"
          :create-endpoint="apiEndpoints.createUser"
          :update-endpoint="apiEndpoints.updateUser"
          :index-endpoint="apiEndpoints.users"
          :delete-endpoint="apiEndpoints.deleteUser"
          :prepare-model="prepareModel"
          :default-model="defaultModel"
        >
          <!-- ********** RESOURCE CREATE FORM ********** -->
          <template v-slot:create-form="{model}">
            <v-row>
              <m-textinput :model="model" name="name" label="User's Full Name"></m-textinput>
            </v-row>
            <v-row>
              <m-textinput :model="model" name="email" label="User's Email" type="email"></m-textinput>
            </v-row>
            <v-row>
              <h3 class="pb-3">Permissions:</h3>
            </v-row>
            <v-row v-for="(description,tag) in userData.can_grant" :key="tag">
              <m-checkbox dense :model="model" :name="tag" :label="description"></m-checkbox>
            </v-row>
          </template>

          <!-- ********** RESOURCE UPDATE FORM ********** -->
          <template v-slot:update-form="{model}">
            <v-row>
              <m-textinput :model="model" name="name" label="User's Full Name"></m-textinput>
            </v-row>
            <v-row>
              <m-textinput :model="model" name="email" label="User's Email" type="email"></m-textinput>
            </v-row>
            <v-row>
              <h3 class="pb-3">Permissions:</h3>
            </v-row>
            <v-row v-for="(description, tag) in userData.can_grant" :key="tag">
              <m-checkbox dense :model="model" :name="tag" :label="description"></m-checkbox>
            </v-row>
          </template>
        </resource-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import apiRequest from "../mixins/api-request";
import apiEndpoints from "../mixins/api-endpoints";
import formatDate from "../mixins/format-date";

export default {
  mixins: [apiRequest, apiEndpoints, formatDate],
  data() {
    return {
      userData:this.loadToken(),
      validationRules: {
        name: model => [
          v => !!v || "Name is required",
          v => (v && v.length >= 5) || "Name must be at least 5 characters"
        ],
        email: model => [
          v => !!v || "User E-mail is required",
          v => /.+@.+\..+/.test(v) || "User E-mail must be valid"
        ],
      },
      defaultModel: {}
    };
  },
  methods: {
    prepareModel(item) {
      //item.active = !!item.active;
      item.created_at = this.fullDateTime(new Date(item.created_at * 1000));
      item.updated_at = this.fullDateTime(new Date(item.updated_at * 1000));
      item.permission_descriptions = item.permission_descriptions.join(
        ".  \r\n"
      );
      item.permissions.forEach(value => {item[value]=true;});
    }
  }
};
</script>
